import { Box, Button, Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import AttachFileSharpIcon from '@mui/icons-material/AttachFileSharp';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { makeStyles } from '@mui/styles';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getDocumentByDocId } from '../../../Utils/apiServices';
import KenDialog from '../../KenDialog';
import KenLoader from '../../KenLoader';
import { useApplicationContext } from '../../../Context/applicationContext';

const useStyles = makeStyles((theme) => ({
  download: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

export default function KenUploadButton(props) {
  const classes = useStyles();
  const { applicationState } = useApplicationContext();
  const { open, recordId, handleDownload, fileType, fileName } = props;
  const [fileBlob, setFileBlob] = useState(null);
  const [pageLoader, setPageLoader] = useState(false);
  const [filePreview, setFilePreview] = useState(false);

  const isApplicationIncomplete = applicationState.applicationData.application.applicationStatus !== 'Submitted';

  const handlPreviewModal = () => {
    setFilePreview(!filePreview);
  };

  const handlePreview = () => {
    setPageLoader(true);
    getDocumentByDocId(recordId)
      .then((res) => {
        if (res?.success && res?.data) {
          setFileBlob(`data:${fileType};base64,${res.data}`);
        }
        handlPreviewModal();
        setPageLoader(false);
      })
      .catch((err) => {
        setPageLoader(false);
        console.error(err);
      });
  };

  function shortenFilename(customFileName) {
    if ((customFileName || '').length > 30) {
      const partOne = (customFileName || '').substring(0, 20);
      const partTwo = (customFileName || '').substring(customFileName.length - 15, customFileName.length);
      return partOne + '.....' + partTwo;
    } else {
      return customFileName;
    }
  }

  return (
    <React.Fragment>
      {pageLoader && <KenLoader />}
      <KenDialog
        open={filePreview}
        handleClose={() => {
          setFilePreview(false);
        }}
      >
        {fileType?.includes('pdf') ? <iframe title={fileName} src={fileBlob} style={{ width: '100%', height: '400px' }} /> : <img alt={fileName} src={fileBlob} style={{ width: '100%', height: '400px', objectFit: 'contain' }} />}
        <Box padding={'10px 0px'}>
          <Button
            variant="outlined"
            onClick={() => {
              handlPreviewModal();
            }}
            style={{ float: 'right' }}
          >
            Close
          </Button>
        </Box>
      </KenDialog>
      {!fileName ? (
        isApplicationIncomplete ? (
          <Button
            variant="secondary"
            onClick={open}
            startIcon={<AttachFileSharpIcon style={{ color: '#092682' }} />}
            style={{
              color: '#092682',
              border: '1px dashed #092682',
              borderRadius: 6,
              width: '100%',
            }}
          >
            Choose or Drag file
          </Button>
        ) : null
      ) : (
        <Box>
          <Grid container spacing={2} alignItems="center">
            <Grid item md={4}>
              <Typography
                style={{
                  color: '#ffffff',
                  fontSize: 14,
                  opacity: '0.6',
                  borderRadius: 6,
                  width: '100%',
                  background: '#008000',
                  textTransform: 'uppercase',
                  padding: '12px 0px',
                }}
              >
                Submitted
              </Typography>
            </Grid>
            <Grid item md={!isApplicationIncomplete ? 4 : 2}>
              {!isApplicationIncomplete ? (
                <Button
                  variant="secondary"
                  onClick={() => {
                    handleDownload(recordId, fileType, fileName);
                  }}
                  startIcon={<FileDownloadIcon style={{ color: '#092682' }} />}
                  style={{
                    color: '#092682',
                    border: '1px dashed #092682',
                    borderRadius: 6,
                    width: '100%',
                  }}
                >
                  Download
                </Button>
              ) : (
                <FileDownloadIcon
                  sx={{ marginTop: '6px' }}
                  className={classes.download}
                  onClick={() => {
                    handleDownload(recordId, fileType, fileName);
                  }}
                />
              )}
            </Grid>
            <Grid item md={!isApplicationIncomplete ? 4 : 2}>
              {!isApplicationIncomplete ? (
                <Button
                  variant="secondary"
                  onClick={() => {
                    handlePreview();
                  }}
                  startIcon={<VisibilityIcon style={{ color: '#092682' }} />}
                  style={{
                    color: '#092682',
                    border: '1px dashed #092682',
                    borderRadius: 6,
                    width: '100%',
                  }}
                >
                  Preview
                </Button>
              ) : (
                <VisibilityIcon
                  sx={{ marginTop: '6px' }}
                  className={classes.download}
                  onClick={() => {
                    handlePreview();
                  }}
                />
              )}
            </Grid>
            {isApplicationIncomplete && (
              <Grid item md={4}>
                <Button
                  variant="secondary"
                  onClick={open}
                  style={{
                    color: '#092682',
                    border: '1px dashed #092682',
                    borderRadius: 6,
                    width: '100%',
                  }}
                >
                  Resubmit
                </Button>
              </Grid>
            )}
          </Grid>
          <Grid container>
            <Grid item md={12} textAlign="left">
              <Typography
                align="left"
                variant="subtitle2"
                sx={{
                  marginBottom: '-20px',
                  marginTop: '8px',
                  color: '#7A869A',
                }}
              >
                {shortenFilename(fileName)}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      )}
    </React.Fragment>
  );
}
